import { Map } from 'immutable';
import React from 'react';
import Component from 'react-pure-render/component';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';

import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react.js';
import UltimaAtualizacaoDataConsulta from '../ultimaatualizacao/UltimaAtualizacaoDataConsulta.react.js';
import * as actions from './Actions.js';
import IntencaoRegistroPrecoLista from './IntencaoRegistroPrecoLista.react.js';

export class IntencaoRegistroPreco extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    modalidades: PropTypes.object.isRequired,
    filtros: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    findIrps: PropTypes.func.isRequired,
    findModalidades: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    resetCrud: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.findModalidades();
    this.onResetFiltro();
  }

  onChangeFiltro = event => {
    this.props.onChange('filtroIrps', event);
  };

  onConsultaIrps = event => {
    const initialPage = this.props.page.set('number', 0);
    this.searchWithPage(initialPage);

    event && event.preventDefault();
    event && event.stopPropagation();
    this.refs.panelFiltroIrps && this.refs.panelFiltroIrps.collapse();
  };

  onResetFiltro = event => {
    const { exercicio } = StorageService.getItem('userInfo');

    event && event.preventDefault();
    event && event.stopPropagation();

    this.props.resetCrud('filtroIrps');
    this.props.onChange('filtroIrps', {
      name: 'ano',
      value: exercicio.id
    });
    this.props.findIrps(`ano=${exercicio.id}`);
  };

  searchWithPage = (page, props) => {
    const { findIrps } = props || this.props;
    findIrps(this.montaFiltro(page));
  };

  montaFiltro = page => {
    const { filtros } = this.props;
    let filter = '';

    if (filtros.get('numero')) {
      filter = addFilterUrl(filter, `numero=${filtros.get('numero')}`);
    }
    if (filtros.get('ano')) {
      filter = addFilterUrl(filter, `ano=${filtros.get('ano')}`);
    }
    if (filtros.get('modalidade')) {
      filter = addFilterUrl(filter, `modalidade=${filtros.get('modalidade')}`);
    }
    if (filtros.get('objeto')) {
      filter = addFilterUrl(
        filter,
        `objeto=${encodeURIComponent(filtros.get('objeto'))}`
      );
    }
    if (filtros.get('dataFimInteresse')) {
      filter = addFilterUrl(
        filter,
        `dataFimInteresse=${filtros.get('dataFimInteresse')}`
      );
    }

    return addPagination(page, filter);
  };

  renderModalidade = modalidade => (
    <option key={modalidade.get('id')} value={modalidade.get('id')}>
      {modalidade.get('descricao')}
    </option>
  );

  render() {
    const { page, modalidades, filtros, location, history } = this.props;

    return (
      <section>
        <PageHeader location={location} />
        <NotasExplicativas pathname={location.pathname} />

        <Panel
          title="Consultar em IRP - Intenção de Registro de Preço"
          mobileClose
          isForm
          ref="panelFiltroIrps"
        >
          <form noValidate>
            <Row>
              <Col xs={6} sm={3} md={2}>
                <Input
                  id="numero"
                  name="numero"
                  label="Número da IRP"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numero')}
                />
              </Col>
              <Col xs={6} sm={3} md={2}>
                <Input
                  id="ano"
                  name="ano"
                  label="Ano da IRP"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('ano')}
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Input
                  id="modalidade"
                  name="modalidade"
                  label="Modalidade"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('modalidade')}
                >
                  <option value="">Selecione</option>
                  {modalidades.map(this.renderModalidade)}
                </Input>
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Input
                  id="objeto"
                  name="objeto"
                  label="Objeto"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('objeto')}
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <DatePicker
                  id="dataFimInteresse"
                  name="dataFimInteresse"
                  label="Data final de manifestação de interesse"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('dataFimInteresse')}
                />
              </Col>
              <Col xs={12}>
                <div className="form-group">
                  <label className="label" />
                  <div className="btn-group">
                    <button
                      id="btnFiltrar"
                      className="btn module-color icon-right"
                      onClick={this.onConsultaIrps}
                    >
                      Pesquisar
                      <em className="fa fa-search" />
                    </button>
                    <button
                      id="btnReset"
                      className="btn neutral icon-right inline no-text"
                      type="button"
                      onClick={this.onResetFiltro}
                    >
                      Limpar
                      <em className="fa fa-times" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </form>
        </Panel>

        <Panel isForm tableResponsive expansible={false}>
          <Row>
            <Col xs={12}>
              <UltimaAtualizacaoDataConsulta />
            </Col>
          </Row>
          <IntencaoRegistroPrecoLista
            page={page}
            searchWithPage={this.searchWithPage}
            history={history}
          />
          <SearchPagination page={page} searchWithPage={this.searchWithPage} />
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    filtros: state.crud.getIn(['filtroIrps', 'currentRecord'], Map({})),
    page: state.irp.get('irps'),
    modalidades: state.irp.get('modalidades')
  };
}

const allActions = {
  ...actions,
  onChange,
  resetCrud
};

export default connect(mapStateToProps, allActions)(IntencaoRegistroPreco);
